import React from "react";

import ProjectMaterialPresetPanel from "./ProjectMaterialPresetPanel";
import SelectedCabinetSimplePanel from "./SelectedCabinetSimplePanel";
import LayoutSimplePanel from "./LayoutSimplePanel";
import FrontSimplePanel from "./FrontSimplePanel";
import ShelvesSimplePanel from "./ShelvesSimplePanel";
import CabinetQuickActionsPanel from "./CabinetQuickActionsPanel";
import SelectedPanelSimplePanel from "./SelectedPanelSimplePanel";

export default function SimplePropertiesPanel({
  selectedNode,
  resolvedNode,
  simpleSelectedNode,
  simpleResolvedNode,
  projectParameters,
  setProjectParameters,
  onChangeNode,
  onQuickAdd,
  definitions = [],
}) {
  const activeSelectedNode = simpleSelectedNode || selectedNode;
  const activeResolvedNode = simpleResolvedNode || resolvedNode;

  const isEditingParent =
    resolvedNode?.id &&
    activeResolvedNode?.id &&
    String(resolvedNode.id) !== String(activeResolvedNode.id);

  return (
    <div className="space-y-4">
      <ProjectMaterialPresetPanel
        projectParameters={projectParameters}
        setProjectParameters={setProjectParameters}
      />

      <SelectedPanelSimplePanel
  selectedNode={selectedNode}
  resolvedNode={resolvedNode}
  onChangeNode={onChangeNode}
  definitions={definitions}
/>

      {isEditingParent && (
        <div className="border rounded p-3 bg-blue-50 text-xs text-blue-700">
          Editing parent cabinet:{" "}
          <span className="font-semibold">
            {activeResolvedNode?.name || activeResolvedNode?.id}
          </span>
        </div>
      )}

      <SelectedCabinetSimplePanel
        selectedNode={activeSelectedNode}
        resolvedNode={activeResolvedNode}
        onChangeNode={onChangeNode}
        onQuickAdd={onQuickAdd}
      />

      <FrontSimplePanel
        selectedNode={activeSelectedNode}
        resolvedNode={activeResolvedNode}
        onChangeNode={onChangeNode}
      />

      <ShelvesSimplePanel
        selectedNode={activeSelectedNode}
        resolvedNode={activeResolvedNode}
        onChangeNode={onChangeNode}
      />

      <CabinetQuickActionsPanel
        selectedNode={activeSelectedNode}
        resolvedNode={activeResolvedNode}
        onChangeNode={onChangeNode}
      />

      <LayoutSimplePanel
        selectedNode={activeSelectedNode}
        resolvedNode={activeResolvedNode}
        onChangeNode={onChangeNode}
      />
    </div>
  );
}